import { BPRegMainParams } from 'legacy/lut/classes/models/onboarding/IRetailRequestData'

/**
 * TEMP (non-prod only): BP_RBI registrations open the internal request-detail page
 * instead of the external BP registration form. Remove this carve-out (and revert the
 * call sites to the plain external-form redirect) once it is ready for production.
 */
export const shouldOpenBpRequestDetail = (spzCode: string | undefined, isProd: boolean): boolean =>
  !isProd && spzCode === BPRegMainParams.InviteRegistr
